import React, { useState } from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import storePersist from '../../../../../redux/storePersist';
import * as R from 'ramda';
export default function SubscriptionAddressInfoComponent ({handleInnerFormChange, subscriptionDetails}: any) {
    const statesItems = storePersist?.get("states")?.current?.items;
    const countryItems = storePersist?.get("countries")?.current?.items;
      const [
        stateValues,
        setStateValues
      ] = useState([])
      const onFilterToStates = (event: any) => {
        handleInnerFormChange(
           event,
          'CountryId'
        );
    
        if (event) {
            const filterStates: any = R.filter(
              (value: any) => value.CountryId === event,
              statesItems
            );
            if (filterStates.length) {
              setStateValues(filterStates);
            } else {
              setStateValues(statesItems);
            }
          } else {
            setStateValues([])
          }
      }
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
<InputContainer
    isRequired
    label="Address1"
    name="Address1"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'Address1'
           );
    }}
    type="text"
    value={subscriptionDetails?.Address1}
/>
<InputContainer
    isRequired
    label="Address2"
    name="Address2"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'Address2'
           );
    }}
    type="text"
    value={subscriptionDetails?.Address2}
/>
<InputContainer
    isRequired
    label="City"
    name="City"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'City'
           );
    }}
    type="text"
    value={subscriptionDetails?.City}
/>
<InputContainer
                    isRequired
                    label="Country Name"
                    labelField="Name"
                    list={countryItems}
                    onValueChange={(event: any, newValue: any) => {
                      onFilterToStates(event.target.value);
                     
                    }}
                    optionName ="Choose country"
                    type="select"
                    value={subscriptionDetails?.CountryId}
                    valueField="Id"
                />
                <InputContainer
                     label="State Name"
                     labelField="Name"
                     list={stateValues}
                     onValueChange={(event: any, newValue: any) => {
                        handleInnerFormChange(
                            event.target.value,
                              'StateProvinceId'
                           );
                     }}
 optionName ="Choose State"
                     type="select"
                     value={subscriptionDetails?.StateProvinceId}
                     valueField="Id"
                 />
                 <InputContainer
    isRequired
    label="ZipPostal Code"
    name="ZipPostalCode"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'ZipPostalCode'
           );
    }}
    type="text"
    value={subscriptionDetails?.ZipPostalCode}
/>
  </div>
  }
  expandedPanel="Address Info"
  headerTitle="Address Info"
/>


        </>
  )
}